module.exports = __webpack_public_path__ + "static/img/2.98391e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/sp/2.png
// module id = OCJv
// module chunks = 0